import { toast } from "sonner";
import request from "../../../helpers/request";

export const postAlertasInserirUsuarioEncaminhado = async ({
  idUsuario,
  idLoja,
  idRegional,
  nomeUsuario,
  idCliente,
}) => {
  if (
    idUsuario == null ||
    idLoja == null ||
    idRegional == null ||
    !nomeUsuario ||
    idCliente == null
  )
    return null;

  const url = `${process.env.REACT_APP_API}/Alerta/AddEncaminhado`;

  const formData = new URLSearchParams();
  formData.append("idUsuario", idUsuario);
  formData.append("idLoja", idLoja);
  formData.append("idRegional", idRegional);
  formData.append("nomeUsuarioEncaminhado", nomeUsuario);
  formData.append("idCliente", idCliente);

  const result = await request({
    url,
    method: "POST",
    data: { idUsuario, idLoja, idRegional, nomeUsuario, idCliente },
  });

  if (result.data) {
    if (
      typeof result.data === "string" &&
      (result.data.includes("Erro") || result.data.includes("error"))
    ) {
      toast.error(result.data.replace(/Erro - /i, ""));
    }
    if (typeof result.data === "string" && result.data.includes("ok")) {
      toast.success("Usuario receberá notificação.");
      return result.data;
    }
  }

  return null;
};
